export default __webpack_public_path__ + "static/media/login-bg.d3395eb9.webp";